import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/category", label: "影视分类" },
  { to: "/topic", label: "影视专题" },
  { to: "/search", label: "搜索" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submitSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) {
      navigate("/search");
      return;
    }
    navigate(`/search?q=${encodeURIComponent(value)}`);
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-primary-800 border-b border-primary-950/40">
      <div className="flex items-center gap-4 h-16 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 shrink-0 mr-2">
          <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
            <i className="ri-moon-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-background-50 font-heading font-bold text-lg tracking-wide whitespace-nowrap">
              夜勤病栋
            </span>
            <span className="text-primary-200 text-[10px] tracking-[0.2em] mt-0.5 hidden sm:block">
              NIGHT DUTY WARD
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 flex-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                  isActive
                    ? "text-background-50 bg-primary-700/70 font-medium"
                    : "text-primary-100 hover:text-background-50 hover:bg-primary-700/40"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form
          onSubmit={submitSearch}
          className="hidden lg:flex items-center gap-2 ml-auto bg-primary-900/50 border border-primary-600/50 rounded-md px-3 h-10 w-64 focus-within:border-accent-400 transition-colors"
        >
          <i className="ri-search-line text-primary-200 text-sm"></i>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索影视作品或资讯"
            className="bg-transparent border-none outline-none text-sm text-background-50 placeholder:text-primary-300 flex-1"
          />
        </form>

        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          aria-label="打开导航菜单"
          className="md:hidden ml-auto w-10 h-10 flex items-center justify-center text-background-50 text-xl cursor-pointer"
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-primary-700/60 bg-primary-800 px-4 pb-4 pt-3">
          <form
            onSubmit={submitSearch}
            className="flex items-center gap-2 bg-primary-900/50 border border-primary-600/50 rounded-md px-3 h-10 mb-3"
          >
            <i className="ri-search-line text-primary-200 text-sm"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视作品或资讯"
              className="bg-transparent border-none outline-none text-sm text-background-50 placeholder:text-primary-300 flex-1"
            />
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 text-sm rounded-md ${
                    isActive
                      ? "text-background-50 bg-primary-700/70 font-medium"
                      : "text-primary-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}